<template>
    <b-form-group :label="$t('Captcha')">
        <b-row>
            <b-col class="col-md-6 col-lg-6 col-xl-6 col-12">
                <img :src="captchaDetails.captchaUrl">
                <span class="reload" @click="refreshCaptcha"><i class="fa fa-sync"></i></span>
            </b-col>
            <b-col class="col-md-6 col-lg-6 col-xl-6 col-12">
                <input type="hidden" v-model="captcha_id">
                <input
                        type="text"
                        class="form-control input-field"
                        v-model="form.captcha"
                        :placeholder="$t('Enter captcha')"
                        required="required">
            </b-col>
        </b-row>
    </b-form-group>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

    export default {
        props: {
            'form':Object
        },
        data() {
            return {
            }
        },
        computed: {
        ...mapGetters('captcha', ['captchaDetails','key'])
    },
    async created()
    {
        this.initializeCaptcha()
       await this.getCaptchaDetails()
    },
    watch:{
        key:{
            immediate:true,
            handler(newValue){
                this.initializeCaptcha()
                 this.form.captcha_id=newValue
            }
        }
    },
    methods: {
        ...mapActions('captcha', ['getCaptchaDetails']),
        refreshCaptcha() {
            this.form.captcha=''
            this.getCaptchaDetails()
        },
        initializeCaptcha(){
            if(!this.form.captcha){
                this.form.captcha = ""
                this.form.captcha_id = ""
            }
        }
    }
    }
</script>